import { io } from "socket.io-client";

// const socket = io("https://alsulaimania.ae", {
const socket = io("wss://socket.dre.ma", {
    transports: ["websocket"],
    autoConnect: true,
    timeout: 60000,
    rejectUnauthorized: false, // Ignore les erreurs de certificat
});

export default socket;
